import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ShieldOff } from "lucide-react";
import { sanitizeCollaboratorStorage } from "./collaboratorAccess";

export default function CollaboratorPortalUnavailable() {
  useEffect(() => {
    sanitizeCollaboratorStorage();
  }, []);

  return (
    <div className="min-h-screen bg-offwhite flex items-center justify-center p-4">
      <div className="glass-panel w-full max-w-2xl rounded-2xl border border-white/50 p-8 shadow-xl">
        <div className="w-16 h-16 bg-red-50 rounded-full flex items-center justify-center mx-auto mb-6 border border-red-100">
          <ShieldOff className="w-8 h-8 text-red-500" />
        </div>
        <div className="text-center space-y-4">
          <h1 className="font-serif text-3xl text-charcoal">Portail collaborateur indisponible</h1>
          <p className="text-sm text-charcoal-soft max-w-xl mx-auto leading-relaxed">
            Cet espace a ete desactive car son authentification reposait uniquement sur des donnees stockees
            dans le navigateur. Les sessions locales existantes ont ete invalidees.
          </p>
          <p className="text-sm text-charcoal-soft max-w-xl mx-auto leading-relaxed">
            La gestion d'equipe reste accessible depuis l'application principale, mais le partage d'un acces
            collaborateur public sera reactive uniquement avec une authentification cote serveur.
          </p>
        </div>
        <div className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Link
            to="/app/team"
            className="btn-sage px-6 py-3 rounded-xl text-xs font-bold uppercase tracking-widest text-center"
          >
            Retour a l'equipe
          </Link>
          <Link
            to="/login"
            className="px-6 py-3 rounded-xl border border-border-cream bg-white/60 text-xs font-bold uppercase tracking-widest text-charcoal text-center"
          >
            Retour a la connexion
          </Link>
        </div>
      </div>
    </div>
  );
}
